export default __webpack_public_path__ + "static/media/search-light.db14a146.svg";